import { fragmentsReducer } from '../features/fragmentsSlice';

export default {
	fragments: fragmentsReducer
};
